module.exports = __webpack_public_path__ + "static/media/laja.d19fe107.jpg";